import { authenticateUserValues } from 'commons/constants';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
import { toast } from '@sparrowengg/twigs-react';
import axios from 'axios';

const normalizeDomain = (domain: string) => domain.replace(/\/$/, '');

export const getMarketplaceDomain = (): string => {
  try {
    const cookies = new Cookies();
    const token = cookies.get(authenticateUserValues.TOKEN);
    if (token) {
      const decoded: Record<string, string> = jwtDecode(token);
      const marketplaceDomain =
        decoded[authenticateUserValues.MARKETPLACE_DOMAIN];
      if (marketplaceDomain) {
        return normalizeDomain(marketplaceDomain);
      }
    }
  } catch (error) {
    console.error(error);
  }
  return normalizeDomain(process.env.REACT_APP_SPARROW_APPS_URL ?? '');
};

const getRedirectLink = async (productId: string | number) => {
  let redirectLink = null;
  try {
    redirectLink = (
      await axios.get(
        `${getMarketplaceDomain()}/api/get-redirect-route-for-product?productId=${productId}`
      )
    ).data;
  } catch (error) {
    console.error(error);
  }
  return redirectLink;
};

export const handleRedirectLink = async () => {
  try {
    const cookie = new Cookies();
    const domain = cookie.get(authenticateUserValues.DOMAIN);
    const token = cookie.get(authenticateUserValues.TOKEN);
    const productId = (jwtDecode(token) as any)?.productId;
    let redirectLink;
    if (productId) {
      redirectLink = (await getRedirectLink(productId)) ?? '/';
    }
    toast({
      variant: 'error',
      description: 'session timeout'
    });
    const redirectUrl =
      domain && redirectLink
        ? `https://${domain}${redirectLink}`
        : (process.env.REACT_APP_APP_V1_URL as string);
    setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 2000);
  } catch (error) {
    console.error(error);
  }
};

export const truncateText = (text: string, count: number) => {
  if (text?.length >= count) {
    return `${text.slice(0, count - 3)}...`;
  }
  return text;
};

export const isValidJSON = (json: string) => {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
};

export const getHeader = () => {
  const cookies = new Cookies();
  const { TOKEN } = authenticateUserValues;
  return { headers: { auth: cookies.get(TOKEN) } };
};

export const wrapCodeInsideFunction = (code: string, functionName: string) => {
  return `${functionName}: async function (args) {
    ${code}
  }`;
};

export const setLocalStorageValue = (property: string, value: string) => {
  window.localStorage.setItem(property, value);
};

export const removeLocalStorageValue = (property: string) => {
  window.localStorage.removeItem(property);
};

export const getLocalStorageValue = (property: string) => {
  return window.localStorage.getItem(property);
};
